import { API_PORTAL_HOME, isApiPortalPath } from '@/features/api-store/domain/apiPortalNavigation';

/**
 * Keeps API-only tenants (`portal_mode = api`) inside the reduced API portal.
 *
 * The existing `entitlementGuard` only enforces `/tools/*`; without this guard
 * an API-only user could still open Home, News or the market dashboards from a
 * bookmark. Public pages and form screens (login, register, the subscription
 * page for adding a plan) stay reachable. Entitlements remain the security
 * boundary — this guard is UX.
 *
 * Registered after the auth guard so the initial session restore has settled
 * and the tenant's portal mode is known.
 */
export function createApiOnlyGuard({ authStore }) {
  return (to) => {
    if (!authStore.isAuthenticated || !authStore.isApiOnly) return undefined;
    if (to.meta?.requiresAuth === false || to.meta?.formScreen) return undefined;
    if (isApiPortalPath(to.path)) return undefined;
    return { path: API_PORTAL_HOME };
  };
}
